import { render, staticRenderFns } from "./CoreScrollUpButton.vue?vue&type=template&id=72e87078&"
import script from "./CoreScrollUpButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreScrollUpButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72e87078')) {
      api.createRecord('72e87078', component.options)
    } else {
      api.reload('72e87078', component.options)
    }
    module.hot.accept("./CoreScrollUpButton.vue?vue&type=template&id=72e87078&", function () {
      api.rerender('72e87078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreScrollUpButton/CoreScrollUpButton.vue"
export default component.exports